var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: "sprite -" + _vm.id + " " + _vm.classes }, [
    _c(
      "svg",
      {
        staticClass: "fill-current transition duration-200 ease-in-out",
        attrs: { viewBox: _vm.viewBox }
      },
      [_c("use", { attrs: { "xlink:href": "#" + _vm.id } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }